import React from 'react'
import PropTypes from 'prop-types'
import {get} from 'lodash'
import className from 'classnames'
import Link from 'next/link'

const ProductItem = ({x}) => {
  return (
    <div className='Products__dl__item'>
      <LinkWrapper x={x}>
        <a className='Products__dl__item__image'>
          <div className='Products__dl__item__image__wrapper'>
            <img
              className='Products__dl__item__image__img'
              alt='Products__dl__item__image__img'
              src={get(x, 'image_1.url')}
              srcSet={`${get(x, 'image_2.url')} 2x`}
            />
          </div>
        </a>
      </LinkWrapper>

      <div className='Products__dl__item__wrapper'>
        <LinkWrapper x={x}>
          <a className='Products__dl__item__dt'>
            {get(x, 'subtitle') ? (
              <React.Fragment>
                <div className='Products__dl__item__dt__wrapper'>
                  {get(x, 'title')}
                </div>

                <span className='Products__dl__item__dt__span'>
                  {get(x, 'subtitle')}
                </span>
              </React.Fragment>
            ) : (
              get(x, 'title')
            )}
          </a>
        </LinkWrapper>

        <dd className='Products__dl__item__dd'>{get(x, 'description')}</dd>

        <div className='Buttons'>
          <a
            className='Products__dl__item__a'
            href={get(x, 'url')}
            target='_blank'
            rel='nofollow noopener noreferrer'
          />
        </div>
      </div>
    </div>
  )
}

ProductItem.propTypes = {}

export default ProductItem

const LinkWrapper = ({x, children}) => (
  <Link href='/products/[id]' as={`/products/${get(x, 'slug')}`}>
    {children}
  </Link>
)
